<template>
  <div>
    <div class="mb-6">
      <figure
        class="w-full relative"
        v-if="variantImage">
        <img
          :src="variantImage.src"
          :alt="variantImage.altText"
          class="object-contain">
      </figure>
    </div>
    <div>
      <div class="flex justify-between items-end my-6">
        <div>
          <h2 class="text-lg leading-snug">
            <span class="font-bold">Panther</span> <span>{{ product.title }}</span>
          </h2>
        </div>
        <div class="ml-auto pl-4">
          <span class="text-lg">NOK {{ parseInt(price) }} (€90)</span>
        </div>
      </div>

      <div class="border-t border-gray-300 mt-6 py-4">
        <div class="flex items-center -ml-2 -mr-2">
          <div class="w-1/3 px-2">Color:</div>
          <div class="w-2/3 px-2">
            <variant-select
              :variants="product.variants"
              v-model="item.variantId" />
          </div>
        </div>

        <div
          v-if="isDirty && item.variantId === null"
          class="bg-red-600 text-white p-2 mt-2 rounded-sm text-sm">
          <p>Please select a size to continue</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VariantSelect from "@/components/VariantSelect"

export default {
  props: {
    product: {
      type: Object,
      default () {
        return {}
      }
    },

    item: {
      type: Object,
      default () {
        return {}
      }
    },

    isDirty: {
      type: Boolean,
      default: false
    },

    index: {
      type: Number,
      default: 0
    }
  },

  components: {
    VariantSelect
  },

  computed: {
    price () {
      let product = this.product.variants.find(product => product.available)
      return product ? product.price : null
    },

    variantImage () {
      return this.product.variants.find(product => product.id === this.item.variantId).image
    }
  }
}
</script>

<style>
  .pb-full {
    padding-bottom: 100%;
  }
</style>
